import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
  render() {
    return (
        <header>
            <nav class="navbar navbar-expand-md bg-dark navbar-dark">
                <Link class="navbar-brand" to="/">STIVAN KITCHOUKOV</Link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul class="navbar-nav">

                       
                        
                        <li class="nav-item">
                            <Link class="nav-link" to="/Certification">Certifications</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to="/Portfolio">My Work</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" to="/Contact">Contact</Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/headerComponent/header.js